import { message } from 'antd';
import { queryCache } from 'react-query';
import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { DbFolder } from '~src/types/db';
import { editFocusOptions, removeFocusOptions } from '~src/services/api';
import { updateCachedFolder } from '~src/services/cache/folders';
import { appLog } from '~src/utils/log';

type UseToggleFocusFolderReturn = {
  toggleFocusFolder: (folder: DbFolder, option: number) => Promise<void>;
};

/** Provides function for folder highlight toggle */
export const useToggleFocusFolder = (): UseToggleFocusFolderReturn => {
  const intl = useIntl();

  /** Toggle folder highlight prop */
  const toggleFocusFolder: UseToggleFocusFolderReturn['toggleFocusFolder'] = useCallback(
    async (folder: DbFolder, option: number) => {
      try {
        const folderId = folder.id;
        if (option === -1) {
          await removeFocusOptions({
            projectId: String(folder.project_id),
            folderId,
          });
        } else {
          await editFocusOptions({
            projectId: String(folder.project_id),
            folderId,
            focustValue: option,
          });
        }

        // to void dropdown stutter
        setTimeout(() => {
          updateCachedFolder(
            folderId,
            { highlight: option },
            { projectId: String(folder.project_id) }
          );
          queryCache.invalidateQueries('folders');
        }, 200);
      } catch (err) {
        appLog('editFocusOptions -> err', err);
        message.error(intl.formatMessage({ id: 'highlight-failed' }));
      }
    },
    [intl]
  );

  return { toggleFocusFolder };
};
